<template>
   
    <modal
          name="jobDescPopModal"
          classes="v-modal-sec"
          :min-width="200"
          :min-height="200"
          :scrollable="true"
          :reset="true"
          width="650px"
          height="auto"
        >
        <div class="v-modal profile_details_modal error-modal-space" >
          <div class="popup-header fromDetailsPage">
            <h2 class="popup-title">
             
              <template v-if="ACTIVITYCODE=='DOL_SUPERVISORY_AUDIT'" >Supervisory Audit</template>
              <template v-else>Update DOL Response</template>
                
                

               </h2>
            <span @click="showPopup=false;$modal.hide('jobDescPopModal');">
              <em class="material-icons">close</em>
            </span>
          </div>
          <form @submit.prevent data-vv-scope="uscisstatus" class="trackingform">
              <div class="form-container" @click="pewResponceUpdateStatusError='' ;showDocumentsError=false ;issuedDateError=false">
                <fileUploadNote :fileNote="true" v-if=" ['UPDATE_DOL_RESPONSE','DOL_SUPERVISORY_AUDIT'].indexOf(ACTIVITYCODE)>-1"/>
                <template >
                     
                <div class="vx-row">
                    <div class="vx-col md:w-1/2 w-full" v-if="ACTIVITYCODE !='DOL_SUPERVISORY_AUDIT'" >
                      <div class="form_group">
                        <label class="form_label">DOL Status<em>*</em></label>
                      <div class="con-select w-full DT_multiselect">                  
                        <multiselect
                          name="casestatus"
                          v-validate="'required'"
                          v-model="actionData.dolStatus"
                          :show-labels="false"
                          @input="clearDateFields"
                          track-by="value"
                          label="text"
                          data-vv-as="Status"
                          placeholder="Choose Status"
                          :options="dolStatusList"
                          :searchable="true"
                          :allow-empty="false"
                        ></multiselect>
                      </div>
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('uscisstatus.casestatus')"
                      >{{ errors.first("uscisstatus.casestatus") }}</span>
                      </div>
                    </div>
                   

                          
                        <template v-if="['DOL_AUDIT' ,'DOL_RECEIVED_RFE'].indexOf(checkProperty(actionData , 'dolStatus','value'))>-1">
                      
                          
                          <div class="vs-col w-1/2 "  >
                          <div class="form_group">
                          <label class="form_label">Receipt Date<em>*</em></label>
                          <div class="vs-component">
                          <datepicker
                            :typeable="true"
                            icon-pack="IntakePortal"
                            icon-after
                            name="issuedDate"
                            @input="updateIssueDate($event)"
                            v-model="actionData.issuedDate"
                            v-validate="'required'"
                            icon="IP-calendar-1"
                            data-vv-as="Receipt Date"
                            placeholder="MM/DD/YYYY"
                            :open-date="new Date(openDate)"
                            :format="customFormatter"
                            :disabled-dates="{from: new Date(startEligibleDate)}"
                          ></datepicker>
                          </div>
                          <span
                            class="text-danger text-sm"
                            v-if="issuedDateError "
                          ><em>* </em> Receipt Date is required</span>
                          </div>
                        </div>
                      </template>
                      <template>
                        <div class="vs-col w-1/2" :class="{'w-full':ACTIVITYCODE =='DOL_SUPERVISORY_AUDIT'}">
                          <div class="form_group">
                          <label class="form_label">Received Date<em>*</em></label>
                          <div class="vs-component">
                          <datepicker  :typeable="true"
                            icon-pack="IntakePortal"
                            icon-after 
                            :format="customFormatter"
                            :disabled-dates="{from: new Date(startEligibleDate)}"
                            name="receivedDate"
                            v-model="actionData.receivedDate"
                            v-validate="'required'"
                            icon="IP-calendar-1"
                            data-vv-as="Received Date"
                            placeholder="MM/DD/YYYY"
                           
                          ></datepicker>
                          </div>
                          <span
                            class="text-danger text-sm"
                            v-if="errors.has('uscisstatus.receivedDate') && !actionData.receivedDate"
                          ><em>* </em> Received Date is required</span>
                          </div>
                        </div>
                      </template>
                      <!-- :open-date="checkReceivedDate" -->
                      <template v-if="['DOL_AUDIT' ,'DOL_RECEIVED_RFE'].indexOf(checkProperty(actionData , 'dolStatus','value'))>-1" >
                        <div class="vs-col w-1/2" >
                          <div class="form_group">
                          <label class="form_label">Expiration Date<em>*</em></label>
                          <div class="vs-component">
                          <datepicker  :typeable="true"
                            icon-pack="IntakePortal"
                            icon-after
                            name="dueDate"
                            :format="customFormatter"
                            :disabled="checkDateDisable"
                            v-model="actionData.dueDate"
                            v-validate="'required'"
                            icon="IP-calendar-1"
                            data-vv-as="Expiration Date"
                            placeholder="MM/DD/YYYY"
                            :disabled-dates="{to: actionData.issuedDate}"
                          ></datepicker>
                          </div>
                          <span
                            class="text-danger text-sm"
                            v-if="errors.has('uscisstatus.dueDate') && !actionData.dueDate"
                          ><em>* </em> Expiration Date is required</span>
                          </div>
                        </div>
                      </template>
                      <template v-if="['DOL_APPROVED'].indexOf(checkProperty(actionData , 'dolStatus','value'))>-1 && ACTIVITYCODE !='DOL_SUPERVISORY_AUDIT'">
                        <datepickerField wrapclass="md:w-1/2" @input="updateValliedDate($event)"
                          
                          :display="true"  v-model="actionData.validFrom" :formscope="'uscisstatus'" fieldName="validFrom" 
                          label="Valid From" :validationRequired="true"   /> 

                          <datepickerField wrapclass="md:w-1/2" 
                           :dateEnableFrom="actionData.validFrom" 
                          :display="true"  v-model="actionData.validTo" :formscope="'uscisstatus'" fieldName="validTo" 
                          label="Valid To" :validationRequired="true" :isDisabled="!actionData.validFrom"  />
                      </template>


                      <!-- <datepickerField  :formscope="'uscisstatus'"  :dateEnableTo="new Date()" :dateEnableFrom="actionData.issuedDate"   wrapclass="md:w-1/2"  v-model="actionData.receivedDate" :cid="'receivedDate'"  :fieldName="'receivedDate'" label="Received Date" :validationRequired="true" /> -->
                   

                      

                      <!-- <template v-if="checkProperty(actionData , 'dolStatus','value')=='DOL_RECEIVED_RFE'">
                       :open-date="new Date(openDate)"
                        :disabled-dates="{from: new Date(startEligibleDate)}"
                        <datepickerField  :formscope="'uscisstatus'"  :dateEnableFrom="actionData.receivedDate"   wrapclass="md:w-1/2"  v-model="actionData.dueDate" :cid="'dueDate'"  :fieldName="'dueDate'" label="Due Date" :validationRequired="true" />
                   
                       
                    </template> -->

                                     
                
                 
               

                  
                  
                </div>

                <div   class="vx-row" @click="documentModel=[]" >
                  
                  <div div class="vx-col w-full">
                    <label class="form_label" style="text-transform: capitalize"> Documents<em>*</em></label>
                    <div class="uploadsec_wrap upload_uscis">
                      <div class="w-full">
                          <div class="relative">
                            <file-upload
                              v-model="documentModel"
                              class="file-upload-input mb-0"
                              style="height:50px;"
                              name="trackingdoc"
                              :multiple="false"
                              @updateData="updateData"
                              data-vv-as="Documents"
                              :accept="allDocEntity"
                              
                            >
                            <!-- @input="uploadDocuments()" -->
                              <img class="file-icon" src="@/assets/images/main/file-upload.svg" />
                              Upload
                            </file-upload>
                            <span class="loader" v-if="filesAreuploading"><img src="@/assets/images/main/loader.gif"></span>
                          </div>
                        <span class="file-type">(File Type: PDF, DOC, JPEG, PNG. Max file size: 200MB)</span>
                        <span v-if="showDocumentsError && actionData['documents'].length<=0 "  class="text-danger text-sm"  ><em>* </em>Documents are required</span>

                          <!-- <VuePerfectScrollbar class="scrollbardoc"> -->
                            
                              <div class="uploded-files_wrap mb-5" v-if="actionData['documents'].length >0 ">
                                  <template v-for="(fil, fileindex) in actionData['documents']">
                                    <div class="w-full"  :key="fileindex" >
                                        <div class="uploded-files">
                                            <vx-input-group class="form-input-group">
                                              <vs-input v-on:keyup="fileNameChenged(fil)"  v-validate="'required'" class="w-full" :name="'fName'+fileindex" v-model="actionData['documents'][fileindex]['name']" data-vv-as="File Name" />
                                                <span class="text-danger text-sm" v-show="errors.has('uscisstatus.fName'+fileindex)">{{ errors.first('uscisstatus.fName'+fileindex) }}</span>

                                                
                                            </vx-input-group>

                                            <div class="form_group">
                                            

                                              
                                            <div class="delete" style="z-index:999" @click="remove(fileindex , actionData['documents'])">
                                                    <img src="@/assets/images/main/delete-row-img.svg" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                 </template>
                              </div>
                          <!-- </VuePerfectScrollbar> -->
                        </div>
                    </div>
                  </div>
                 
                 

                
                </div>

                <div class="vx-col w-full">
                      <div class="form_group">
                        <label class="form_label">Document Type<em>*</em></label>
                        <div class="con-select w-full DT_multiselect">  
                        <!-- {{documentType}}                 -->
                          <multiselect
                            :name="'documentType'"
                            v-validate="'required'"
                            v-model="actionData.documentType"
                            :show-labels="false"
                            
                            data-vv-as="Document Type"
                            placeholder="Document Type"
                            :options="documentTypes"
                            :searchable="true"
                            :allow-empty="false"
                          >
                          </multiselect>
                        
                          <span  class="text-danger text-sm"  v-show="errors.has('uscisstatus.documentType')"  >{{ errors.first('uscisstatus.documentType') }}</span>
                        </div>
                      </div>
                    </div>

                </template>
               
                <div class="vx-col  w-full"  >
                   <div class="form_group">
                     <label class="form_label">Comments</label>
                             <!-- <vs-textarea name="Comments" v-model="actionData.comment"   class="w-full" :data-vv-as="'Comments'" /> -->
                             <ckeditor  name="Comments" v-model="actionData.comment"   class="w-full" :data-vv-as="'Comments'" :editor="editor" :config="editorConfig"></ckeditor>
                         <p v-show="errors.has('uscisstatus.Comments')" class="text-danger text-sm"><em>* </em>Comments are required</p>
                    </div>
                  </div>
              </div>

         
              
              <div @click="pewResponceUpdateStatusError=''" class="text-danger text-sm formerrors padremove" v-if="pewResponceUpdateStatusError!=''">
                        <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal" icon="IP-information-button" active="true">{{ pewResponceUpdateStatusError }}</vs-alert>
              </div>

              <div class="popup-footer relative">
              <span class="loader" v-if="pwdResUpdating"><img src="@/assets/images/main/loader.gif"></span>
                <vs-button color="dark" class="cancel" type="filled" @click="documentModel=[]; hideMe()">Cancel</vs-button>
                <vs-button color="success" :disabled="pwdResUpdating" @click="submitForm()" class="save" type="filled">
                
                 
                <template>Submit</template>
                
                
                </vs-button>
              </div>
          </form>
          </div>
        </modal>  
</template>
<script>
import FileUpload from "@/views/FileUpload.vue"
import fileUploadNote from "@/views/common/fileUploadNote.vue";
import moment from "moment";
//import FileUpload from "vue-upload-component/src";
import { EyeIcon } from "vue-feather-icons";
import docType from "@/views/common/docType.vue";
import Datepicker from "vuejs-datepicker-inv";
import * as _ from "lodash";
import immiInput from "@/views/forms/fields/simpleinput.vue";
import immitextarea from "@/views/forms/fields/simpletextarea.vue";
import selectField from "@/views/forms/fields/simpleselect.vue";
import datepickerField from "@/views/forms/fields/datepicker.vue";
import Vue from 'vue';
Vue.use( CKEditor );
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
provide() {
        return {
           parentValidator: this.$validator,
        };
    },
components: {
  datepickerField,
  docType,
  EyeIcon,
  FileUpload,
  Datepicker,
  immiInput,
  immitextarea,
  fileUploadNote,
  selectField
},
methods: {
  updateValliedDate(){
    if(val){
        if(this.actionData.validTo){
          let startData = moment(val);
          let endData= moment(this.actionData.validTo)
          if(startData.isAfter(endData , 'day')){
            this.actionData.validTo = null
          }
        }
      }else{
        this.actionData.validTo = null;
      }
  },
  updateData(docs){
    this.actionData['documents'] = docs;
  },
  updateIssueDate(val){
    if(val && this.checkProperty(this.actionData , 'dolStatus','value')=='DOL_RECEIVED_RFE'){
      // if(this.actionData['receivedDate']){
      //   let startData = moment(val);
      //   let endData= moment(this.actionData['receivedDate'])
      //   if(startData.isAfter(endData , 'day')){
      //     this.actionData['receivedDate'] = null
      //   }
      // }
      if(this.actionData['dueDate']){
        let startDate = moment(val);
        let endDate= moment(this.actionData['dueDate'])
        if(startDate.isAfter(endDate , 'day')){
          this.actionData['dueDate'] = null
        }
      }
    }
  },
  clearDateFields(){
    this.actionData['issuedDate'] = null
    this.actionData['validFrom'] = null
    this.actionData['validTo'] = null
    this.actionData['receivedDate'] = null
    this.actionData['dueDate'] = null;
    this.issuedDateError =false;
    this.$validator.reset();
  },
    updatesocCode(item){ 

      if(_.has( item ,'id')){
      this.actionData['socCode'] = item['id'];
      }
    },
  getMasterSocList(){

            let query = {};
            query["page"] = 1;
            query["perpage"] = 10000;
            query["matcher"] = {};
            query["category"] = "soc_codes";


            this.$store
            .dispatch("getMasterData", query)
            .then((response) => {
            this.masterSocList = response.list;
            if(this.ACTIVITYCODE =="DOL_SUPERVISORY_AUDIT"){
              this.actionData.dolStatus ={  value: "DOL_SUPERVISORY_AUDIT", text: "Supervisory Audit",  }
            }


            //alert(this.perpage);
            })
            .catch(() => {
            this.masterSocList = [];
            if(this.ACTIVITYCODE =="DOL_AUDIT"){
               // this.actionData.dolStatus ={  value: "DOL_AUDIT", text: "Case Audit",  }
            }

            });

  },
  remove(index ,docs){
    docs.splice(index ,1);
    this.showDocumentsError =false;
    if(this.actionData['documents'].length<=0){
        this.showDocumentsError =true;
    }

  },
  /**
   * 
   * @param userType | String
   * @param typeId | String
   * @param childrenId | String
   * @param userName | String
   */
  uploadDocuments(){
       let docs =_.cloneDeep(this.documentModel);
       this.documentModel=[];
        
          docs = docs.map(
              (item) =>{
                  item = {
                      name: item.name,
                      file: item.file,
                      path: "",
                      mimetype: item.type,
                      extn:item.extn?item.extn:'',
                      documentType:item.documentType?item.documentType:null,
                      userName:''
                     
                  }
                 
                  
              return item;

            }
          );
         
          if (docs.length > 0) {
              var self = this;
              this.filesAreuploading = true;
              
              let count =0;
              docs.forEach(function (doc) {
                  let formData = new FormData();
                  formData.append("files", doc.file);
                  formData.append("secureType", "private");
                  formData.append("getDetails", true);
                  self.$store.dispatch("uploadS3File", formData).then((response) => {
                    count = count+1;
                      if (response.data && response.data.result) {
                          response.data.result.forEach((urlGenerated) => {
                            //alert(JSON.stringify(urlGenerated))
                              // doc.url = urlGenerated;
                               doc.path = urlGenerated['path'];
                               doc.mimetype = urlGenerated['mimetype'];
                                doc.extn = urlGenerated['extn'];
                               
                              delete doc.file;
                              if(urlGenerated['path']){
                                 self.actionData['documents'].push(doc);
                                 self.showDocumentsError =false;
                               //  self.statusDocuments.push(doc)
                              }
                              
                              if(parseInt(count)>=docs.length){
                                 self.filesAreuploading = false;
                                 self.pwdResUpdating =false;
                               

                              }
                          });
                          if(count>=docs.length){
                            self.filesAreuploading = false;
                            self.pwdResUpdating =false;
                         

                          }
                          
                      }
                     
                  });
              });
          }
  },
 
    
  fileNameChenged(index, fileindex) {
          this.disable_uploadBtn = false;

          _.forEach(this.actionData['documents'], (doc, value) => {
              let fname = doc.name;
              fname = fname.trim();

              if (!fname) {
                  this.disable_uploadBtn = true;
              }
          });

      },


    
  submitForm() {
     //alert(this.approveRejecInstructions);
          this.pewResponceUpdateStatusError='';
          this.showDocumentsError =false;
          this.issuedDateError =false;
       
          this.$validator.validateAll("uscisstatus").then((result) => {
            if(this.checkProperty(this.actionData ,'documents' ,'length')<=0){
                this.showDocumentsError =true;
              }


             
              if( ['DOL_AUDIT' ,'DOL_RECEIVED_RFE'].indexOf(this.checkProperty(this.actionData, 'dolStatus','value')) >-1 && !this.checkProperty(this.actionData,  'issuedDate')){
                this.issuedDateError =true;
              }


             if(!this.showDocumentsError && result && !this.filesAreuploading && !this.issuedDateError){
              this.pwdResUpdating =true;
              let path ="/perm/manage-approval-process";
              let data ={today:null,action:'' ,'petitionId':'' ,"typeName": "", 	"subTypeName": "", description:'', "receivedDate":null,"documents":[] ,'documentType':'Original'};

              data["receivedDate"] = moment(this.actionData['receivedDate']).format( "YYYY-MM-DD");
              data['action'] = this.checkProperty(this.actionData, 'dolStatus','value');
              if( ['DOL_AUDIT' ,'DOL_RECEIVED_RFE'].indexOf(data['action'])>-1){
                data = Object.assign(data , {'dueDate':null,"issuedDate":null});
                
                data["dueDate"] =  moment(this.actionData['dueDate']).format( "YYYY-MM-DD");
                data["issuedDate"] = moment(this.actionData['issuedDate']).format( "YYYY-MM-DD"); 

              }
              if(['DOL_APPROVED'].indexOf(data['action'])>-1 && this.ACTIVITYCODE !='DOL_SUPERVISORY_AUDIT'){
                data = Object.assign(data , {'validFrom':null,"validTo":null});
                data["validFrom"] =  moment(this.actionData['validFrom']).format( "YYYY-MM-DD");
                data["validTo"] = moment(this.actionData['validTo']).format( "YYYY-MM-DD"); 
              }
              
              data['documents'] = this.actionData['documents'];
              
              data['comment'] = this.actionData['comment']
              data['typeName'] = this.checkProperty( this.petitionDetails , 'typeDetails','name');
              data['subTypeName'] = this.checkProperty( this.petitionDetails ,'subTypeDetails','name');
              data['petitionId'] = this.checkProperty( this.petitionDetails ,'_id');
              data['today']=moment().format( "YYYY-MM-DD"); 
              data['documentType'] = this.actionData['documentType']
              this.$store.dispatch('commonAction' ,{ "data":data ,'path':path})
              .then((res)=>{
                this.showToster({message:res['message'],isError:false });
                this.hideMe();
                this.$emit("updatepetition");
              })
              .catch((error)=>{
                this.pewResponceUpdateStatusError =error;
                this.pwdResUpdating =false;
               })

              

             }
          });
  },
  hideMe() {

    this.$emit("hideMe");
    setTimeout(()=>{
        this.$modal.hide('jobDescPopModal');
      },10);
  },
},
watch: {
  showPopup(val) {
    if (!val){
      this.$emit("hideMe");
      this.$modal.hide('jobDescPopModal');
    } 
  },
},
mounted() {
 
  
    this.getMasterSocList();
    this.showPopup = true;
    if(this.ACTIVITYCODE =="DOL_SUPERVISORY_AUDIT"){
       this.actionData.dolStatus ={  value: "DOL_SUPERVISORY_AUDIT", text: "Supervisory Audit",  }
    }
   
    this.$modal.show('jobDescPopModal');
  
},
data: () => ({
  editor: ClassicEditor,
 editorConfig: {
     toolbar: [ 'bold', 'italic', '|', 'undo','redo'  ,'NumberedList', 'BulletedList', ],
 },
    //"DOL_APPROVED" / "DOL_RECEIVED_RFE" / "DOL_DENIED" / "DOL_WITHDRAWN" /DOL_SUPERVISORY_AUDIT, DOL_AUDIT
    showDocumentsError:false,
    issuedDateError:false,
    dolStatusList:[
      

        {
        value: "DOL_APPROVED",
        text: "Case Certified",
      },
     /*
      {
        value: "DOL_RECEIVED_RFE",
        text: "RFE Received",
      },
      */
      {
        value: "DOL_DENIED",
        text: "Case Denied",
      },
      {
        value: "DOL_AUDIT",
        text: "Case Audit",
      },
      // {
      //   value: "DOL_SUPERVISORY_AUDIT",
      //   text: "Case Supervisory  Audit",
      // },
      
      // {
      //   value: "DOL_WITHDRAWN",
      //   text: "Case Withdrawn",
      // },

    ],
  masterSocList:[],
  pwdResUpdating:false,
  pewResponceUpdateStatusError:'',
  actionData:{
       dolStatus:null,
      "petitionId": "",
      "action": '',//"EFILE_PWD",'UPDATE_PWD_RESPONSE'
      "typeName": "t",
      "subTypeName": "",
        "issuedDate": null,
        "receivedDate": null,
        "dueDate": null,
        "documentType": "Original",
      comment:'',
      "documents": [],
      "today":null,
      validFrom:null,
      validTo:null,
      
},

 
  
 documentTypes:["Original" ,"Electronic" ],
  documentModel:[],
  statusDocuments:[],
 filesAreuploading: false,
  
  uploading: false,
  courierList: [],
  tracking: { documents: [], receiptNumber: null, receiptName: null },
  
  
  openDate: new Date().setFullYear(new Date().getFullYear()),
  startEligibleDate: new Date().setFullYear(new Date().getFullYear()),
  
  disabled_btn: false,
  showPopup: false,
  documents: [],
 
}),
props: {
  ACTIVITYCODE: {
    type: String,
    default: null,
  },
  petitionDetails: {
    type: Object,
    default: null,
  },
},
computed:{
    checkDateDisable(){
      let returnVal = false;
      if(this.actionData.issuedDate == null){
      returnVal = true;
      }
      return returnVal
  },
  checkreceivedDate(){
    let returnVal = {from: new Date()};
    if(this.actionData.issuedDate){
      returnVal ={to: this.actionData.issuedDate ,from: new Date()};
    }
    return returnVal;

  },
  checkDisabledDates(){
    if(this.checkProperty(this.actionData , 'dolStatus','value')=='DOL_RECEIVED_RFE' && 
    (this.checkProperty(this.actionData,'issuedDate')==null || this.checkProperty(this.actionData,'issuedDate')=='')){
      return true
    }
    else{
      false
    }
  }
},
};
</script>
